import { Suspense } from 'react';
import VividiRegisterMachine from './Machine';
const VividiRegister = () => <Suspense fallback={<></>} data-sentry-element="Suspense" data-sentry-component="VividiRegister" data-sentry-source-file="index.tsx">
    <VividiRegisterMachine data-sentry-element="VividiRegisterMachine" data-sentry-source-file="index.tsx" />
  </Suspense>;
export default VividiRegister;